import React, { useEffect, useState } from "react";
import { MDBCol, MDBRow } from "mdbreact";
import { Button } from "evergreen-ui";
import { Form, Input, Select } from "antd";
import { useListVals } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import { v4 as uuidv4 } from 'uuid';
import { filterSelectOption, sortSelectOptions } from "../../../utils/selectOptions.js";

var moment = require("moment");
const { TextArea } = Input;
const db = getDatabase(Firebase);

const OrganizationsActionsLayout = (props) => {
	const [orgForm] = Form.useForm();
	const [name, setName] = useState(null);
	const [countries] = useListVals(ref(db, "talmidsdb/countries"));
	const [organisations] = useListVals(ref(db, "talmidsdb/organisations"));
	const [userArray] = useListVals(ref(db, "talmidsdb/users"));
	const [SFOrgID, setSFOrgID] = useState(null);

	const handleCreate = (values) => {
		if (values.organisation.includes("/")) {
			alert("the code cannot include a slash, use a dash or another symbol instead")
		} else {
			var timeStamp = moment().format("YYYY-MM-DDTh:mm:ss");
			var objectID = uuidv4();
			var object = {
				"name": values.organisation,
				"id": objectID,
				"SFOrgID": values.SFOrgID,
				"countryID": values.countryID,
				"startDate": moment().format("YYYY-MM-DD"),
				"responsibleUserID": values.responsibleUserID,
				"notes": values.notes
			}
			Object.entries(object).forEach(([key, value]) => {
				if (value === undefined) {
					object[key] = "";
				}
			});
			orgForm.resetFields();
			props.createCallback("organisations", objectID, object);
		}
	}

	return (
		<div className="font-Nunito">
			<MDBRow>
				<MDBCol className="px-4">
					<Form layout="vertical" onFinish={handleCreate} form={orgForm}>
						<Form.Item label="Enter organisation name"
							name="organisation">
							<Input type="text"
								placeholder="enter Organization name"
								className="w-100 mr-4"
								onChange={(e) => { setName(e.target.value) }}
								value={name}
								id="email"
							/>
						</Form.Item>
						<Form.Item label="Enter organisation SFOrgID"
							name="SFOrgID">
							<Input type="text"
								placeholder="enter Organisation SFOrgID"
								className="w-100 mr-4"
								onChange={(e) => { setSFOrgID(e.target.value) }}
								value={SFOrgID}
								id="email"
							/>
						</Form.Item>
						<Form.Item
							label="Enter organisation country"
							name="countryID"
							id="countryID"
							rules={[{ required: true }]}
						>
							<Select placeholder="select Organization Country"
								showSearch
								optionFilterProp="children"
								filterOption={filterSelectOption}
								filterSort={sortSelectOptions}>
								{countries.map((item, index) => (
									<Select.Option value={item.id} key={index}>{item.countryName}</Select.Option>
								))}
							</Select>
						</Form.Item>
						<Form.Item
							label="Select responsible User"
							name="responsibleUser"
							id="responsibleUserID"
						>
							<Select placeholder="Select responsible User"
								showSearch
								optionFilterProp="children"
								filterOption={filterSelectOption}
								filterSort={sortSelectOptions}>
								{userArray.map((item, index) => (
									<Select.Option key={index} value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
								))}
							</Select>
						</Form.Item>
						<Form.Item
							label="notes"
							name="notes"
							id="notes"
						>
							<TextArea placeholder="notes" />
						</Form.Item>
						<Button appearance="primary" className="mt-3" htmlType="submit">Create</Button>
					</Form>
				</MDBCol>
			</MDBRow>
		</div>
	)
}

export default OrganizationsActionsLayout;
